import { render } from "./inventariosobrante.vue?vue&type=template&id=a48179a8&scoped=true"
import script from "./inventariosobrante.vue?vue&type=script&lang=js"
export * from "./inventariosobrante.vue?vue&type=script&lang=js"

import "./inventariosobrante.vue?vue&type=style&index=0&id=a48179a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48179a8"]])

export default __exports__